/**
 * Card Dynamic Component
 */

import { SecureOtpRequest } from "@kushki/js/lib/types/secure_otp_request";
import { SubscriptionTokenRequest } from "@kushki/js/lib/types/subscription_token_request";
import { TokenRequest } from "@kushki/js/lib/types/token_request";
import { ErrorMessage } from "components/Error/ErrorMessageComponent";
import { Input } from "components/Input/InputComponent";
import { FooterImageComponent } from "components/UI/FooterImageComponent/FooterImageComponent";
import { PayButton } from "components/UI/PayButton/PayButtonComponent";
import { VoucherViewComponent } from "components/VoucherView/VoucherViewComponent";
import { OtpContainer } from "components/WaitingView/OtpComponent";
import {
  deleteErrorMessage,
  enableCvvView,
  getCardBrand,
  getListBrandsLogosMerchant,
  getSubscriptionCardToken,
  hideModal,
  setDirty,
  showNesterErrorModal,
  updateEmailValidity,
  updateInput,
  updateOtpValue,
  validateOtp,
} from "containers/Card/store/Actions";

import { getBinFromCreditCardNumber } from "@kushki/js/lib/service/UtilsService";
import { SubscriptionCardAsyncTokenRequest } from "@kushki/js/lib/types/subscription_card_async_token_request";
import { Footer } from "components/UI/Footer/FooterComponent";
import { OtpExceededRetriesContainer } from "components/WaitingView/OtpExceededRetriesComponent";
import { CardAction } from "containers/Card/store/CardAction";
import { CardState } from "containers/Card/store/CardState";
import { getCardSubscriptionAsyncToken } from "containers/CardSubscriptionAsync/store/ActionCreators";
import { CardSubscriptionDynamicState } from "containers/CardSubscriptionDynamic/store/CardSubscriptionDynamicState";
import * as React from "react";
import { LocalizeContextProps, withLocalize } from "react-localize-redux";
import { connect } from "react-redux";
import { Col, Row } from "reactstrap";
import { Dispatch } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { CurrencyEnum } from "root/shared/CurrencyEnum";
import { sendParametersToParent } from "root/shared/Messenger";
import { PaymenMethodEnum } from "root/shared/PaymenMethodEnum";
import {
  calculateTotalAmount,
  checkValidity,
  getUrlIconBrand,
} from "root/shared/Utility";
import { CajitaStore, IInputProps } from "root/store/CajitaStore";
import { MessengerParams } from "types/remote/messenger_params";
import { ITransferAmount } from "types/transfer_amount";

/**
 * CardSubscriptionDynamicComponent Class
 */

class CardSubscriptionDynamic extends React.Component<
  CardSubscriptionDynamicState & LocalizeContextProps,
  object
> {
  private cardSubscriptionDynamicFormRef: React.RefObject<
    HTMLFormElement
  > = React.createRef();
  private inputCard: IInputProps | null;

  constructor(props: CardSubscriptionDynamicState & LocalizeContextProps) {
    super(props);

    this.inputCard = null;

    this.props.addTranslation(this.props.translation);
    this._genericInputHandler = this._genericInputHandler.bind(this);
    this._cardNumberHandler = this._cardNumberHandler.bind(this);
    this._expDateHandler = this._expDateHandler.bind(this);
    this._submitHandler = this._submitHandler.bind(this);
    this._genericInputHandler = this._genericInputHandler.bind(this);
    this._charge = this._charge.bind(this);
    this._validateOtp = this._validateOtp.bind(this);
    this._getBrandCard = this._getBrandCard.bind(this);
    this._getCardsMerchant = this._getCardsMerchant.bind(this);
    this._cvcInputHandler = this._cvcInputHandler.bind(this);
  }

  public render(): React.ReactNode {
    return (
      <form
        onSubmit={this._submitHandler}
        autoComplete="off"
        noValidate={true}
        ref={this.cardSubscriptionDynamicFormRef}
      >
        <VoucherViewComponent />
        <ErrorMessage />
        {!this.props.showWaitModal ? (
          <div id="card-dynamic-container">
            {this.props.listBrandsLogosMerchant.length > 0 ? (
              <FooterImageComponent
                icons={this.props.listBrandsLogosMerchant}
              />
            ) : null}
            <Row className="mb-20">
              <Col xs={12}>
                <Input
                  {...this.props.cardHolder}
                  change={this._genericInputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
              <Col xs={12}>
                <Input
                  {...this.props.cardNumber}
                  change={this._cardNumberHandler}
                  touched={this.props.onTouched}
                />
              </Col>
              <Col xs={6} className="pr-8">
                <Input
                  {...this.props.expDate}
                  change={this._expDateHandler}
                  touched={this.props.onTouched}
                />
              </Col>
              <Col xs={6} className="pl-8">
                <Input
                  {...this.props.cardCVC}
                  change={this._cvcInputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
              <Col xs={12}>
                <Input
                  {...this.props.email}
                  change={this._genericInputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
            </Row>
          </div>
        ) : (
          <div id="otp-card-subscription-dynamic">
            {this.props.exceededRetries === true ? (
              <OtpExceededRetriesContainer />
            ) : (
              <OtpContainer />
            )}
          </div>
        )}
        {!this.props.showWaitModal ? (
          <PayButton
            isValid={
              this.props.isValid &&
              // istanbul ignore next
              this.props.email.valid
            }
            totalAmount={this.props.amount}
            isSubscription={true}
            currency={this.props.currency}
            disable={this.props.disablePayButton}
          />
        ) : null}
        <Footer showLanguajeToggle={this.props.isLanguageToggleAvailable} />
      </form>
    );
  }

  public componentDidMount(): void {
    this.props.enableTokenWithoutCvv();
    this.props.updateEmailValidity();
    this._getCardsMerchant();
  }

  public componentDidUpdate(): void {
    // istanbul ignore next
    if (
      this.props.token !== undefined &&
      (this.props.waitingViewEnabled === false ||
        this.props.otpState === true) &&
      this.props.showVoucher === false
    ) {
      const params: MessengerParams = {
        token: this.props.token,
        paymentMethod: PaymenMethodEnum.CARD,
      };

      this.props.hideModal();
      this._charge(params);

      return;
    }

    if (this.inputCard !== null && this.inputCard.hasOwnProperty("classes")) {
      const classes: string[] = ["input", "input-cardNumber"];

      this.inputCard.classes = classes;

      if (this.props.brand.length > 0) {
        this.inputCard.classes.push(this.props.brand);
        this.inputCard.card = {
          name: this.props.brand,
          urlIcon: getUrlIconBrand(
            this.props.brand,
            this.props.listBrandsLogosMerchant
          ),
        };
        this.props.onChangeInput(this.inputCard);
      }
    }

    if (
      this.props.secureServiceId !== undefined &&
      this.props.otpValue !== undefined &&
      this.props.failOtpMessage === undefined
    ) {
      this._validateOtp(this.props.secureServiceId, this.props.otpValue);
      this.props.updateOtpValue(undefined);

      return;
    }

    if (this.props.failOtpMessage !== undefined) {
      this.props.showNesterErrorModal();
      this.props.deleteErrorMessage();

      return;
    }

    // istanbul ignore else
    if (
      this.props.token !== undefined &&
      this.props.token !== "" &&
      this.props.cardType === "debit"
    )
      sendParametersToParent({
        token: this.props.token,
        paymentMethod: PaymenMethodEnum.CARD_SUBSCRIPTION_ASYNC,
      });

    return;
  }

  private _getCardsMerchant(): void {
    this.props.getCardsMerchant();
  }

  private _validateOtp(secureServiceId: string, otpValue: string): void {
    this.props.validateOtp({ secureServiceId, otpValue: otpValue });
  }

  private _charge(params: MessengerParams): void {
    // Charge
    sendParametersToParent(params);
  }

  private _expDateHandler(id: string, value: string): void {
    const new_input: IInputProps = { ...this.props[id] };
    const arr: RegExpMatchArray = value.split("/");

    switch (true) {
      case parseInt(arr[0], 10) > 12:
        arr[0] = "12";
        break;
      case arr[0] === "00":
        arr[0] = "01";
        break;
      case arr[1] === "00":
        arr[1] = "01";
        break;
      default:
        break;
    }

    new_input.value = arr.join("/");
    new_input.valid = checkValidity(value, new_input.rules);
    this.props.onChangeInput(new_input);
  }

  private _submitHandler(event: React.FormEvent<HTMLFormElement>): void {
    event.preventDefault();

    this.props.cardType === "debit"
      ? this._cardSubscriptionAsyncTokenHandler()
      : this._cardSubscriptionTokenHandler();
  }

  private _cardSubscriptionAsyncTokenHandler(): void {
    const subscriptionCardAsyncTokenRequest: SubscriptionCardAsyncTokenRequest = {
      currency: "CLP",
      email: this.props.email.value,
      amount: this.props.amount,
      callbackUrl: this.props.callbackUrl,
      cardNumber: this.props.cardNumber.value,
    };

    this.props.requestCardSubscriptionAsyncToken(
      subscriptionCardAsyncTokenRequest
    );
  }

  private _cardSubscriptionTokenHandler(): void {
    const date: string[] = this.props.expDate.value.split(
      this.props.expDate.separator
    );
    // @ts-ignore
    const body: TokenRequest = {
      card: {
        cvc: this.props.cardCVC.value === "" ? null : this.props.cardCVC.value,
        expiryMonth: parseInt(date[0], 10).toString(),
        expiryYear: date[1],
        name: this.props.cardHolder.value,
        number: this.props.cardNumber.value
          .split(this.props.cardNumber.separator)
          .join(""),
      },
      currency: this.props.currency,
      isDeferred: false,
      amount: this.props.amount,
    };

    this.props.tokens_subscription(body);
  }

  private _cardNumberHandler(id: string, value: string): void {
    const new_input: IInputProps = { ...this.props[id] };

    if (value.length === 9 || value.length > 18) this._getBrandCard(value);

    new_input.valid = checkValidity(value, new_input.rules);
    new_input.value = value;

    this.inputCard = new_input;

    this.props.onChangeInput(new_input);
  }

  private _getBrandCard(cardBin: string): void {
    this.props.cardBrand(getBinFromCreditCardNumber(cardBin));
  }

  private _genericInputHandler(id: string, value: string): void {
    const new_input: IInputProps = { ...this.props[id] };

    new_input.valid = checkValidity(value, new_input.rules);
    new_input.value = value;

    this.props.onChangeInput(new_input);

    return;
  }

  private _cvcInputHandler(id: string, value: string): void {
    const new_input: IInputProps = { ...this.props[id] };

    if (this.props.currency === CurrencyEnum.CLP) new_input.valid = true;
    else new_input.valid = checkValidity(value, new_input.rules);

    new_input.value = value;

    this.props.onChangeInput(new_input);

    return;
  }
}

const mapStateToProps: (state: CajitaStore) => CardState = (
  state: CajitaStore
): CardSubscriptionDynamicState => ({
  ...state.card,
  amount:
    typeof state.config.amount === "object"
      ? calculateTotalAmount(state.config.amount as ITransferAmount)
      : state.config.amount,
  currency: state.config.currency,
  showWaitModal: state.card.waitingViewEnabled,
  otpState: state.card.otpState,
  otpErrorMessage: state.card.failOtpMessage,
  brand: state.card.brand,
  cardType: state.card.cardType,
  token:
    state.card.token !== undefined && state.card.token !== ""
      ? state.card.token
      : state.card_subscription_async.token,
  isLanguageToggleAvailable: true,
  callbackUrl: state.config.callback_url,
  disablePayButton: state.config.disablePayButton,
});

const mapDispatchToProps: (dispatch: Dispatch) => object = (
  dispatch: ThunkDispatch<CajitaStore, undefined, CardAction>
): object => ({
  onChangeInput: (payload: IInputProps): void => dispatch(updateInput(payload)),
  onTouched: (payload: IInputProps): CardAction => dispatch(setDirty(payload)),
  cardBrand: (binNumber: string): void => dispatch(getCardBrand(binNumber)),
  getCardsMerchant: (): void => dispatch(getListBrandsLogosMerchant()),
  tokens_subscription: (payload: SubscriptionTokenRequest): void =>
    dispatch(getSubscriptionCardToken(payload)),
  validateOtp: (payload: {
    secureServiceId: string;
    otpValue: string;
  }): void => {
    const otp_request: SecureOtpRequest = {
      secureServiceId: payload.secureServiceId,
      otpValue: payload.otpValue,
    };

    dispatch(validateOtp(otp_request));
  },
  hideModal: (): void => dispatch(hideModal()),
  showNesterErrorModal: (): void => dispatch(showNesterErrorModal()),
  deleteErrorMessage: (): void => dispatch(deleteErrorMessage()),
  updateOtpValue: (payload: string): void => dispatch(updateOtpValue(payload)),
  enableTokenWithoutCvv: (): void => dispatch(enableCvvView()),
  updateEmailValidity: (): void => dispatch(updateEmailValidity(false)),
  requestCardSubscriptionAsyncToken: (
    payload: SubscriptionCardAsyncTokenRequest
  ): void => dispatch(getCardSubscriptionAsyncToken(payload)),
});

const CardSubscriptionDynamicComponent: React.ComponentClass = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withLocalize<CardSubscriptionDynamicState & LocalizeContextProps>(
    CardSubscriptionDynamic
  )
);

export { CardSubscriptionDynamicComponent };



// WEBPACK FOOTER //
// ./src/containers/CardSubscriptionDynamic/CardSubscriptionDynamic.tsx